import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

interface Props {
  count?: number;
}

const DEFAULT_SKELETON_COUNT = 12;

// Placeholder cards shown while a search is in flight, so the results page
// renders instantly with the request image instead of a blocking spinner.
// Dimensions mirror the real Product card to avoid layout shift on swap.
function ProductSkeleton({ count = DEFAULT_SKELETON_COUNT }: Props): JSX.Element {
  return (
    <div className="contents" aria-hidden="true">
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className={twMerge([
            'wrap-main-item-result',
            'max-w-[190px] w-[180px] desktop:w-[190px]',
            'border border-solid border-[#E0E0E0]',
            'overflow-hidden',
          ])}
        >
          <div className="h-[168px] bg-[#f3f3f5] animate-pulse" />
          <div className="flex flex-col gap-2 px-2 pt-3 pb-4 bg-white">
            <div className="h-3 w-4/5 rounded bg-[#f3f3f5] animate-pulse" />
            <div className="h-3 w-2/5 rounded bg-[#f3f3f5] animate-pulse" />
          </div>
        </div>
      ))}
    </div>
  );
}

export default memo(ProductSkeleton);
